import { render, staticRenderFns } from "./SettingIntroBanner.vue?vue&type=template&id=3054d15c&scoped=true&"
import script from "./SettingIntroBanner.vue?vue&type=script&lang=js&"
export * from "./SettingIntroBanner.vue?vue&type=script&lang=js&"
import style0 from "./SettingIntroBanner.vue?vue&type=style&index=0&id=3054d15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054d15c",
  null
  
)

export default component.exports